import { DateTime } from 'luxon'
import { Dispatch, EnumDispatchState, EnumDispatchType } from '../../../../api'
import { DownloadFileRequestModel } from '../../../../api/Pioneer/endpoints/files/models/files'
import { EnumFileType } from '../../../../api/Pioneer/enums/enumFileType'
import { enumKeyToValue } from '../../../../helpers'
import { CommunicationSendsDownloadMode, DispatchModel } from './comunicationSends.model'
import { getGlobalActionsConfiguration } from './comunicationSends.service'

export const comunicationsSendsListItemsMapper = (items: Dispatch[]): DispatchModel[] => {
  return items && items.map(comunicationsSendsListItemMapper)
}

export const comunicationsSendsListItemMapper = (item: Dispatch): DispatchModel => {
  return (
    item && {
      id: item.id,
      dischargeDate: getFormatedDate(item.fechaAlta),
      state: enumKeyToValue(EnumDispatchState, item.state),
      fileName:
        item.urlRequest !== undefined && item.urlRequest !== null
          ? getFileName(item.urlRequest)
          : undefined,
      urlRequest: item.urlRequest,
      urlResponse: item.urlResponse,
      urlResponseConciliation: item.urlResponseConciliation,
      dispatchMaster: item.dispatchMaster,
      dispatchType: enumKeyToValue(EnumDispatchType, item.dispatchMaster.dispatchType),
      operations: item.operationsCV.concat(item.operationsLog),
      actionsConfiguration: getGlobalActionsConfiguration(),
      isDownloadVisible: item.urlRequest !== null && item.urlRequest !== undefined ? true : false
    }
  )
}

const getFileName = (url: string) => {
  let splitedName1 = url.split('/')
  let splitedName2 = splitedName1[splitedName1.length - 1].split('\\')
  return splitedName2[splitedName2.length - 1]
}

const getFormatedDate = (dateString: Date) => {
  let date = new Date(dateString)
  let utc = DateTime.utc(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  )
  return utc.toLocal().toFormat('dd/MM/yyyy HH:mm:ss')
}

export const mapSendToDownloadRequest = (
  dispatchId: number,
  mode: CommunicationSendsDownloadMode
): DownloadFileRequestModel => {
  return {
    blobFiles: [
      {
        documentType: EnumFileType.DispatchDocument,
        dispatchId: dispatchId,
        dispatchResponse: mode === CommunicationSendsDownloadMode.Response,
        dispatchResponseConciliation: mode === CommunicationSendsDownloadMode.Conciliation
      }
    ]
  }
}
